$(function () {
    var __accad = {
        historyArr: [],
        timer: null,
        unique: function (arr) {
            for (var i = 0; i < arr.length; i++) {
                for (var j = i + 1; j < arr.length; j++) {
                    if (arr[i] == arr[j]) {
                        arr.splice(j, 1);
                        j--;
                    }
                }
            }
            return arr;
        },
        IsPC: function () {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"
            ];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        },
        init: function () {
            if (window.localStorage && window.localStorage.getItem("historyLog") != null) {
                var historyLog = window.localStorage.getItem("historyLog");
                __accad.historyArr = historyLog.split(",");
            }
            if (__accad.historyArr.length) {
                __accad.cloneHistory();
            } else {
                $(".history").hide();
            }

            var keywords = $('.keywords').val();

            !keywords ? __accad.changeNav.call($('.nav-active')) : '';
        },
        cloneHistory: function () {
            __accad.historyArr = __accad.unique(__accad.historyArr);

            $(".history-blocks").html("");
            __accad.historyArr.forEach((item) => {
                $(".history-blocks").append($(`._initList .${item}`).clone(false));
            })

            $(".history-blocks").css('width', (3.55 * __accad.historyArr.length + 0.2) + 'rem');
            $(".history").show();
        },
        changeNav: function () {
            var idx = $(this).index();

            $(".keywords").val('');
            $('.search-list').html("").hide();
            $("._initList").css("visibility", "inherit");
            $(this).addClass("nav-active").siblings().removeClass("nav-active");
            $(".list-blocks").eq(idx).show().siblings(".list-blocks").hide();
        },
        inHistory: function () {
            var className = $(this).attr("data-name");

            __accad.historyArr.unshift(className);
            __accad.historyArr = __accad.unique(__accad.historyArr);
            if (__accad.historyArr.length > 5) {
                __accad.historyArr.pop();
            }
            window.localStorage.setItem("historyLog", __accad.historyArr);
            __accad.cloneHistory();
        },
        showLayer: function () {
            $(".layer").addClass("animation");
        },
        hideLayer: function () {
            $(".layer").removeClass("animation");
        },
        showLayer2: function () {
            if ($(".layer2").is(':hidden')) {
                $(".layer2").show();
            } else {
                $(".layer2").hide();
            }
        },
        jumpUrl: function () {
            var href = $(this).attr('data-href'),
                isUse = $(this).attr('data-is-use');

            if (!href) {
                layer.msg('本学会无相关系统');
                return;
            }

            if (isUse == 2) {
                // layer.msg('暂未开通');
                $('.dialog').show()
                __accad.timer = setTimeout(function () {
                    window.open(href);
                }, 5000)

            } else {
                window.open(href);
            }

        },
        closeDialog: function () {
            clearTimeout(__accad.timer)
            $('.dialog').hide()
        }
    }

    __accad.init();



    $(document)
        .on("click", ".nav-line", __accad.changeNav)
        .on("click", ".list-block", __accad.inHistory)
        .on("click", "._showLayer", __accad.showLayer)
        .on("click", ".layer-close", __accad.hideLayer)
        .on("click", "._showLayer2", __accad.showLayer2)
        .on("click", "._linkHref", __accad.jumpUrl)
        .on("keyup", __accad.search)
        .on("click", "._btn", __accad.closeDialog)

})